import { Context, createContext } from 'react';

export interface GlobalPriceData {
    globalPriceData: any;
    setGlobalPriceData: any;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const PriceDataContext: Context<GlobalPriceData> = createContext({ globalPriceData: { priceForProductInstances: {} }, setGlobalPriceData: (setData) => {} } as GlobalPriceData);
export default PriceDataContext;
